export const initialState = {
  error: null,
  sendError: null,
  isLoading: false,
  isSuccess: false,
  isUpdating: false,
};
